import { useState, useEffect } from 'react'

import SearchIcon from '@mui/icons-material/Search'
import { chainPropTypes } from '@mui/utils'
import {
  Button,
  CheckBox,
  Grid,
  Input,
  Row,
  Select,
  AutoCompleteInput
} from 'components'
import { useDebounce, useModal } from 'hooks'
import useLoading from 'hooks/useLoading'
import { UserCsnService } from 'services/Supplier/Users'
import { SPACING } from 'utils'

import { ManageCreFilterProps } from '../../ManageCre'
import { UseFormSetValue, UseFormWatch } from 'react-hook-form'

interface IManageCreFilterProps {
  setIdAnalista: React.Dispatch<React.SetStateAction<number>>
  handleDesignate: () => void
  handleFilterTableData: () => void
  checkTodos: () => boolean
  watch: UseFormWatch<ManageCreFilterProps>
  reset: any
  setValue: UseFormSetValue<ManageCreFilterProps>
}
const ManageCreFilter = ({
  setIdAnalista,
  handleDesignate,
  handleFilterTableData,
  checkTodos,
  watch,
  reset,
  setValue
}: IManageCreFilterProps) => {
  const checarTodos = checkTodos()
  const { showModal } = useModal()
  const { setLoading } = useLoading()

  const selectedAnalitas = watch('analistas')
  const matriculaAnalista = watch('matriculaAnalista')

  const [analistas, setAnalistas] = useState<
    {
      label: string
      value: any
    }[]
  >([{ label: '', value: {} }])
  const walletInfoCre = watch('walletInfoCre')

  const filterSearch = watch('filterSearch')

  const [matriculas, setMatriculas] = useState<
    {
      label: string
      value: any
    }[]
  >([{ label: '', value: {} }])

  const handleSelectedValue = (value) => {
    setValue('matriculaAnalista', value.nmMatricula)

    if (value.usuario?.nmUsuario != null && value?.nmMatricula != null)
      setValue(
        'analistas',
        value.usuario?.nmUsuario + ' - ' + value?.nmMatricula
      )
    else setValue('analistas', '')

    setIdAnalista(value.usuario?.idUsuario || null)
  }

  const handleSearchAnalista = (event) => {
    reset()
    setLoading('loading')
    if (event.target.value === '') {
      setLoading('idle')
      return
    }
    UserCsnService()
      .getByNome(event.target.value, true, true)
      .then((response) => {
        const selectedFieldOptions = response.data.map((analista) => ({
          label: analista.usuario.nmUsuario + ' - ' + analista.nmMatricula,
          value: analista
        }))

        setAnalistas(selectedFieldOptions)
        setLoading('idle')
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter os dados do Analista',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  const handleSearchMatricula = (event) => {
    setMatriculas([])
    setLoading('loading')
    if (event.target.value === '') {
      setLoading('idle')
      return
    }
    UserCsnService()
      .getByMatricula(event.target.value, true)
      .then((response) => {
        const selectedFieldOptions = response.data.map((analista) => ({
          label: analista.nmMatricula,
          value: analista
        }))

        setMatriculas(selectedFieldOptions)
        setLoading('idle')
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter os da Matrícula',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  return (
    <>
      <Row
        gap="2rem"
        marginTop={SPACING.spacing20}
        marginBottom={SPACING.spacing20}
      >
        <CheckBox
          checked={walletInfoCre.PrimeiraMob}
          label="1ª Mobilização"
          onChange={(e) => {
            setValue('walletInfoCre.PrimeiraMob', !walletInfoCre.PrimeiraMob)
          }}
        />
        <CheckBox
          checked={walletInfoCre.UltMed}
          label="Ult. Mobilização"
          onChange={(e) => {
            setValue('walletInfoCre.UltMed', !walletInfoCre.UltMed)
          }}
        />
        <CheckBox
          checked={walletInfoCre.Denuncia}
          label="Denúncia"
          onChange={(e) => {
            setValue('walletInfoCre.Denuncia', !walletInfoCre.Denuncia)
          }}
        />
        <CheckBox
          checked={walletInfoCre.Projeto}
          label="Projeto"
          onChange={(e) => {
            setValue('walletInfoCre.Projeto', !walletInfoCre.Projeto)
          }}
        />
        <CheckBox
          checked={walletInfoCre.Alerta}
          label="Alerta"
          onChange={(e) => {
            setValue('walletInfoCre.Alerta', !walletInfoCre.Alerta)
          }}
        />
        <CheckBox
          checked={checarTodos}
          label="Todos"
          onChange={() => {
            if (!checarTodos) {
              setValue('walletInfoCre', {
                Alerta: false,
                Denuncia: false,
                PrimeiraMob: false,
                Projeto: false,
                UltMed: false
              })
            }
          }}
        />
      </Row>
      <Grid
        gridCols="3fr 1.5fr 3.5fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <AutoCompleteInput
          name="nomeAnalista"
          onChangeText={useDebounce(handleSearchAnalista, 500)}
          value={selectedAnalitas}
          // loading={unidadeGestoraLoading.Gerencia}
          options={analistas}
          noFilter
          optionValue="label"
          label="Nome Analista"
          onChange={(selectedValue, value) => {
            handleSelectedValue(value)
          }}
          valueName="value"
        />

        <AutoCompleteInput
          name="matriculaAnalista"
          onChangeText={useDebounce(handleSearchMatricula, 500)}
          value={matriculaAnalista || null}
          options={matriculas || []}
          noFilter
          optionValue="label"
          label="Matrícula Analista"
          onChange={(selectedValue, value) => {
            handleSelectedValue(value)
          }}
          valueName="value"
        />

        <div />
      </Grid>
      <Row
        justifyContent="flex-end"
        alignItems="center"
        marginTop={SPACING.spacing15}
        marginBottom={SPACING.spacing10}
      >
        <Button
          onClick={() => handleDesignate()}
          text="Designar"
          marginRight={SPACING.spacing15}
        />
        <Input
          value={filterSearch}
          onChange={(e) => setValue('filterSearch', e.target.value)}
          onClickIcon={() => handleFilterTableData()}
          label="Pesquisa Geral"
          placeholder="Pesquisar"
          inputIcon={<SearchIcon />}
          maxLength={100}
        />
      </Row>
    </>
  )
}

export default ManageCreFilter
